/**
 * 51esc web — punto de entrada TypeScript.
 *
 * Inicializa los módulos del frontend según la página activa. Vite usa este
 * archivo como entry point del index.html principal (la sala de operaciones).
 */

import { initScene } from './modules/scene/index.js';
import { initRadio } from './modules/radio/index.js';

// Detectar página activa por la presencia de elementos clave.
const isScenePage = document.querySelector('.scene-wrapper') !== null;

if (isScenePage) {
  initScene();
  initRadio();
}
